export function loadRegion(regionName) {
  return {
    type: 'LOAD_REGION',
    regionName: regionName
  }
}

export function loadedRegion(regionName, regionData) {
  return {
    type: 'LOADED_REGION',
    regionName: regionName,
    regionData: regionData
  }
}

export function loadCollection(name) {
  return {
    type: 'LOAD_COLLECTION',
    name: name,
  }
}

export function loadedCollection(name, data) {
  return {
    type: 'LOADED_COLLECTION',
    name: name,
    data: data
  }
}


// WEBPACK FOOTER //
// ./src/reducers/actions.js